export const newsConsts = {
    GET_ALL_NEWS: "GET_ALL_NEWS",
    GET_NEWS_FOR_SLIDER: "GET_NEWS_FOR_SLIDER",
    UPDATE_NEWS_BY_ID: "UPDATE_NEWS_BY_ID",
    DELETE_NEWS_BY_ID: "DELETE_NEWS_BY_ID",
    CREATE_NEWS_BLOCK: "CREATE_NEWS_BLOCK",
};